import React from "react";

const Dashboard16pxSvg = ({ className }) => {
  return (
    <svg
      className={className}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="11.5" width="23.99" height="2.99" rx="1" fill="currentColor" />
      <rect y="3.50977" width="20" height="2.99" rx="1" fill="currentColor" />
      <rect y="19.48" width="15.99" height="2.99" rx="1" fill="currentColor" />
    </svg>
  );
};

export default Dashboard16pxSvg;
